import { IconProps } from './iconTypes';

export const AgentIsAway = ({ color, ...props }: IconProps): JSX.Element => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
        <path
            d="M22.0002 20.74L20.5402 19.28L6.21023 4.94999L2.25023 0.98999L0.990234 2.24999L3.69023 4.94999H3.05023C1.94023 4.94999 1.06023 5.83999 1.06023 6.94999L1.05023 17.95C1.05023 19.06 1.94023 19.95 3.05023 19.95H18.6902L20.7402 22L22.0002 20.74ZM21.0002 6.94999C21.0502 5.83999 20.1602 4.94999 19.0502 4.99999H15.0502V2.94999C15.0502 1.83999 14.1602 0.94999 13.0502 0.99999H9.05023C7.94023 0.94999 7.05023 1.83999 7.05023 2.94999V3.26999L21.0002 17.27V6.94999ZM13.0502 4.99999H9.00023V2.94999H13.0502V4.99999Z"
            fill={color}
        />
    </svg>
);
